"use strict";
/*
 * Created on 31.01.2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../../modules/AppModule");

var EntityChangeConverter_1 = require("./conversions/EntityChangeConverter");

var EntityChangeConverterImpl_1 = require("./conversions/EntityChangeConverterImpl");

var EntityChangeSetInfoConverter_1 = require("./conversions/EntityChangeSetInfoConverter");

var EntityChangeSetInfoConverterImpl_1 = require("./conversions/EntityChangeSetInfoConverterImpl");
/**
 * @author MSu
 */


var HistoryAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(HistoryAppModule, _AppModule_1$AppModul);

  function HistoryAppModule() {
    var _this;

    _classCallCheck(this, HistoryAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HistoryAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'historyAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(HistoryAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(EntityChangeConverter_1.EntityChangeConverter).to(EntityChangeConverterImpl_1.EntityChangeConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(EntityChangeSetInfoConverter_1.EntityChangeSetInfoConverter).to(EntityChangeSetInfoConverterImpl_1.EntityChangeSetInfoConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return HistoryAppModule;
}(AppModule_1.AppModule);

exports.HistoryAppModule = HistoryAppModule;